<template>
    <v-field :has-error="hasError" :error-label="errorLabel" :helper="helper">
        <q-uploader ref="uploader"
                    :float-label="label | capitalize"
                    :hide-underline="hideUnderline"
                    :hide-upload-button="hideUploadButton"
                    :url="url"
                    :color="color"
                    :method="method"
                    :extensions="extensions"
                    :multiple="multiple"
                    :headers="headers"
                    auto-expand
                    :clearable="clearable"
                    :disable="uploading || disable"
                    @uploaded="onSuccess"
                    @fail="onFail"></q-uploader>
    </v-field>
</template>

<script>
    import mixins from './mixins'
    import {QUploader} from 'quasar-framework'
    import store from '../../store'
    import * as types from '../../store/mutation-types'
    import i18n from '../../plugins/i18n'

    // Get the response interceptors from axios plugin
    import axios from 'axios'

    let responseInterceptors = axios.interceptors.response.handlers

    export default {
        name: 'VFile',

        mixins,

        props: {
            value: {},
            url: {
                type: String,
                required: true
            },
            method: {
                type: String,
                default: 'POST'
            },
            hideUploadButton: Boolean,
            extensions: String,
            multiple: Boolean
        },

        components: {
            QUploader
        },

        data() {
            return {
                uploader: {}
            }
        },

        mounted() {
            this.uploader = this.$refs.uploader
        },

        computed: {
            uploading() {
                return this.uploader.uploading
            },

            headers() {
                var headers = {}

                const token = store.getters['auth/token']
                if (token)
                    headers['Authorization'] = `Bearer ${token}`

                const locale = store.getters['lang/locale']
                if (locale)
                    headers['Accept-Language'] = locale

                return headers
            }
        },

        methods: {
            onSuccess(file, xhr) {
                this.$emit("uploaded", xhr)
            },

            onFail(file, xhr) {
                responseInterceptors.forEach(interceptor => interceptor.rejected({
                    response: {
                        status: xhr.status
                    }
                }))
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/form/VFile.vue